<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-10">
                        <div class="font-weight-bold body-1">
                            Detalles de Proforma
                        </div>
                    </v-col>
                </v-row> 
                <v-row justify="center">
                    <v-col cols="12" md="10" >
                        <details-item key="infoKey" :detailsItems="items"></details-item>

                        <Separator title="Partidas" v-if="products.length > 0"/>
                        <table-items
                            :props="tableProps" :items="products"
                        >
                            <template v-slot:item.iva="props">
                                <div class="table-item">
                                    <div v-for="(item, index) in props.item.taxes" :key="index" class="">
                                        <div class="sale-bill-tax-item px-3">
                                            <p class="mb-0 font-weight-bold">{{item.name}} ({{ut.getPercentage(item.rate, 1)}}%)</p>
                                            <p class="mb-0">{{ut.currencyFormat(item.total, props.item.currency)}}</p>
                                        </div>
                                    
                                    </div>
                                    
                                </div>
                            </template>
                        </table-items>
                    </v-col>
                    
                </v-row>
                

            </div>
            <v-row justify="center" align="end">
				<v-col cols="12" md="10" class="d-flex justify-end">
                    
					<primary-button :props="cancelBtnData"></primary-button>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import DetailsItem from '../../components/DetailsItem.vue';
import Separator from '../../components/Separator.vue';
import Utils from "../../helpers/Utils";
import TableItems from '../incomes/TableItems.vue';
export default {
    components: {
        TableItems,
        DetailsItem,
        Separator
    },
	data(){
		return {
            id: this.$route.params.id,
            infoKey:1,
            ut: Utils,
            loading: false,
           
            items: [
               
                
            ],
            products:[],
           
            cancelBtnData: {
                text: "Regresar",
                icon: "",
                to: "SaleBills",	
                click: () => {}
            },
            tableProps: {
				headers: [
                     {
						text: 'Producto',
						align: 'left small-th-always',
						value: 'id_product',
                        sortable: false,
						class: 'table-b-border black--text small-th-always'
					},
					{
						text: 'Cant.',
						align: 'left small-th-always',
						value: 'quantity',
						sortable: false,
                       
						class: 'table-b-border black--text small-th-always'
					},
                    {
						text: 'Unidad',
						align: 'left small-th-always',
						value: 'unitText',
						sortable: false,
						class: 'table-b-border black--text small-th-always'
					},
                    {
						text: 'Concepto',
						align: 'left small-th-always',
						value: 'description',
						sortable: false,
                        width: '30%',
						class: 'table-b-border black--text small-th-always'
					},
                     {
						text: 'P.U.',
						align: 'right small-th-always',
						value: 'unit_price',
                        width: '10%',
						sortable: false,
						class: 'table-b-border black--text small-th-always'
					},
                    {
						text: 'Impuestos',
						align: 'center small-th-always',
						value: 'iva',
						sortable: false,
                        width: '15%',
						class: 'table-b-border black--text small-th-always'
					},
                     {
						text: 'Importe',
						align: 'right small-th-always',
						value: 'total',
						sortable: false,
                        width: '10%',
						class: 'table-b-border black--text small-th-always'
					},
                  
				],
				items: [],
				search: '',
				loading: false,
                keyValue: 0,
			},
         
          
		}
    },
    mounted(){
        this.index();
    },
	methods: {
		validate () {
			return this.$refs.form.validate()
		},
        index(){
			//this.$store.state.overlay = true
			this.loading = true;
            this.$store.state.loading = true;
			this.$api.saleBill.get(this.$store.state.business, this.id)
			.then((response) => {
               
                this.items= [
                    { concepto: 'Fecha', index: 'data', valor:Utils.globalDateFormat(response.data.date??"") },
                    { concepto: 'Cliente', index: 'customer', valor: response.data?.customer?.name??'' },
                    { concepto: 'OT', index: 'reference', valor: response.data?.reference?.name??'' },
                    { concepto: 'Divisa', index: 'currency', valor: response.data?.currency??'' },
                    { concepto: 'Método de pago', index: 'payment_method', valor: response.data?.payment_method??'' },
                    { concepto: 'Tipo de comprobante', index: 'cfdi_type', valor: response.data?.cfdi_type??'' },
                    { concepto: 'Forma de pago', index: 'payment_form', valor: response.data?.payment_form??'' },
                    { concepto: 'Estatus', index: 'payment_form', valor: this.getStatus(response.data?.status??'' )},
                    { concepto: 'Comentarios', index: 'comments', valor: response.data?.comments??'' },
                ];


                //products
                response.data.items.forEach(item => {
                    this.products.push({
                        id_product: item.id_product,
                        quantity: item.quantity,
                        unitText: `${item.unit_code} - ${item.unit}`,
                        description: item.description,
                        unit_price: Utils.currencyFormat(item.unit_price, response.data.currency),
                        iva: '',
                        total: Utils.currencyFormat(item.total, response.data.currency),
                        taxes: item.taxes,
                        currency: response.data.currency,
                    });
                });

                this.getPaymentMethods(response.data.payment_method);
                this.getCfdiTypes(response.data.cfdi_type);
                this.getPaymentForms(response.data.payment_form)


               

			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
				this.loading = false;
                this.$store.state.loading = false;
			})
		},
        getStatus(value){
            if(value == 'PENDING'){
                return 'Pendiente';
            }
			if(value == 'PAID'){
                return 'Pagado';
            }
			if(value == 'CANCELLED'){
                return 'Cancelado';
            }
            return value;
        },

        getPaymentMethods(value)
        {
            this.loadingPM = true;
            this.$api.taxInvoice.paymentsMethods()
                .then((resp) => {
                    const found = resp.data.find((x) => x.Value == value)
                    if(found == undefined) return;
                    let selected = this.items.find((x) => x.index == 'payment_method')
                    selected.valor = `${value} - ${found.Name}`;

                    this.infoKey = this.infoKey + 1;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingPM = false;
                })
            ;
        },
        getCfdiTypes(value)
        {
            this.loadingCfdiTypes = true;
            this.$api.taxInvoice.cfdiTypes()
                .then((resp) => {
                    const found = resp.data.find((x) => x.Value == value)
                    if(found == undefined) return;
                    let selected = this.items.find((x) => x.index == 'cfdi_type')
                    selected.valor = `${value} - ${found.Name}`;

                    this.infoKey = this.infoKey + 1;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingCfdiTypes = false;
                })
            ;
        },
        getPaymentForms(value)
        {
            this.loadingPaymentForms = true;
            this.$api.taxInvoice.paymentForms()
                .then((resp) => {
                    const found = resp.data.find((x) => x.Value == value)
                    if(found == undefined) return;
                    let selected = this.items.find((x) => x.index == 'payment_form')
                    selected.valor = `${value} - ${found.Name}`;

                    this.infoKey = this.infoKey + 1;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingPaymentForms = false;
                })
            ;
        },
       
    },
}
</script>

<style lang="scss">
    .v-skeleton-loader__text{
        margin-bottom: 0px;
    }
    .pre{
        white-space: pre-line;
    }

    .receipt-details-image-container{
        background-color: rgb(232, 231, 231);
    }

    .sale-bill{
       
        &-tax-item{
            margin: .5rem 0;
            display: flex;
            flex-direction: column;
            border: solid 1px var(--v-line-base);
            align-items: center;
            border-radius: .3rem;
            
        }

        &-tax-container{
            padding: 1px 5px;
            background-color: var(--v-inputsBackground-base);
        }

      
    }
</style> 